import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const initialState = {
  isFormDirty: false, // ← any unsaved form currently active
  otherPendingPath: "",    // optional: path to navigate after confirm
  showLeaveConfirm: false,
  notChatScreen: false,
  isNavigatingAway: false, // track if user navigate to other screen, not navigate back to its own screen
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setIsFormDirty: (state, action) => {
      state.isFormDirty = action.payload;
    },
    setOtherPendingPath: (state, action) => {
      state.otherPendingPath = action.payload;
    },
    setShowLeaveConfirm: (state, action) => {
      state.showLeaveConfirm = action.payload;
    },
    setNotChatScreen: (state, action) => {
      state.notChatScreen = action.payload;
    },
    setIsNavigatingAway: (state, action) => {
      state.isNavigatingAway = action.payload;
    }
  },
});

export const {
  setIsFormDirty,
  setOtherPendingPath,
  setShowLeaveConfirm,
  setNotChatScreen,
  setIsNavigatingAway
} = appSlice.actions;

export default appSlice.reducer;
